export default __webpack_public_path__ + "static/media/dalalbull.73fd64af.png";